<template>
  <div
    class="lecture-item"
    :class="{
      'past-time-item': cssPastTime
      }"
    >
    <div v-if="lecture.duration > 0" class="lecture-time">
      <p class="time-start">
        {{ $t('shared.lecture.start_at_label') }} {{ timeStart }}
      </p>
      <p class="time-start">
        {{ lecture.duration }} {{ $t('shared.lecture.minuts') }}
      </p>
    </div>
    <div class="lecture-title">
      <p>
        {{ lecture.title }}
      </p>
    </div>
    <div class="lecture-mark">
      <button
        @click="lectureMark()"
        class="btn btn-sm btn-accent"
      >
        <i :class="{
          'exu-bookmark': !markedLecture,
          'exu-bookmark-check-fill': markedLecture
        }" />
      </button>
    </div>
    <div
      v-if="isModerator && isSpeakers"
      class="lecture-moderate">
      <span class="moderate-item">{{ $t('shared.lecture.moderator') }}:</span>
        <span
          v-for="moderator in ModeratorList"
          :key="moderator.id"
          class="moderate-item"
        >
          {{ moderator.name}}
        </span>
    </div>
    <div
      v-if="isSpeakers"
      class="lecture-speaker">
      <i class="exu-mic"/>
      <router-link
        v-for="speaker in lecture.speakers"
        :key="speaker.id"
        :to="{ path: speakerLink(speaker.id) }"
        class="speaker-item"
      >
        {{ speaker. name}}
      </router-link>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { DateTime } from 'luxon';

export default {
  name: 'LectureItem',
  props: {
    lecture: {
      type: Object,
      default: () => ({}),
    },
    moderators: {
      type: Array,
      default: () => ([]),
    },
    markedLecture: {
      type: Boolean,
      default: false,
    },
    doScrollLecture: {
      default: null,
    },
    pastTimeItem: {
      type: Number,
      default: null,
    },
  },
  computed: {
    timeStart() {
      return DateTime.fromMillis(this.lecture.start_ts)
        .setZone(this.$store.getters.getTime_UTC)
        .toFormat('H:mm');
    },
    isModerator() {
      return this.lecture.moderators.length > 0 || null;
    },
    ModeratorList() {
      if (this.lecture.moderators.length > 0) {
        return this.lecture.moderators;
      }
      return [];
    },
    isSpeakers() {
      return this.lecture.speakers.length > 0;
    },
    dataForMarkFavorit() {
      return {
        id: this.lecture.id,
        start_ts: this.lecture.start_ts,
        duration_ts: this.lecture.duration_ts,
        place: null,
        main_title: null,
        sub_title: this.lecture.title,
        moderators: [],
        speakers: this.isSpeakers ? this.lecture.speakers : [],
        type: 'lecture',
      };
    },
    cssPastTime() {
      return this.pastTimeItem !== null
        ? this.lecture.start_ts + this.lecture.duration_ts < this.pastTimeItem
        : false;
    },
  },
  mounted() {
    if (this.doScrollLecture) {
      setTimeout(() => {
        document.querySelector(`#${this.doScrollLecture}`)
          .scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 200);
    }
  },
  methods: {
    // moderatorLink(id) {
    //   return `/speaker/profile/${id}`;
    // },
    speakerLink(id) {
      return `/speaker/profile/${id}`;
    },
    lectureMark() {
      this.$emit('mark-lecture', this.dataForMarkFavorit);
    },
  },
};
</script>

<style lang="scss" scoped>
.lecture {
  &-item {
    display: grid;
    grid-template-columns: [left-line] 1fr [middle-line] auto [right-line];
    grid-template-rows: [top-line] auto [time-line] auto
      [title-line] auto [bottom-line];
    gap: 3px 5px;
    font-size: 14px;
  }
  &-time {
    grid-column: left-line / right-line;
    grid-row: top-line / time-line;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    color: #356899;

    &>p {
      margin: 0;
    }
  }
  &-mark {
    grid-column: middle-line / right-line;
    grid-row: time-line / bottom-line;
  }
  &-title {
    grid-column: left-line / middle-line;
    grid-row: time-line / title-line;
    color: #356899;
    font-style: normal;
    line-height: 1.2rem;
    &>p {
      margin: 0;
    }
  }
  &-speaker {
    grid-column: left-line / middle-line;
    grid-row: title-line / bottom-line;
  }
  &-speaker, &-moderate {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    column-gap: 15px;
    align-items: center;
    color: #95969D;

    .speaker-item, .moderate-item {
      display: block;
      color: #2c3e50;
      font-size: 14px;
      text-decoration: none;
      outline: none;
      white-space: nowrap;

      &.current {
        color: #356899;
      }
    }
  }
  &-item.past-time-item &-time,
  &-item.past-time-item &-title,
  &-item.past-time-item &-speaker .speaker-item,
  &-item.past-time-item &-moderate .moderate-item {
    color: #95969D;
  }
}
.lecture-item {
  // scroll-margin-top: -160px;
}
.btn-accent {
  color: #D76535;
  font-size: 1.5rem;
  padding: 0;
  border: none;
  // border: 2px solid #D76535;

  &:active {
    color: #D76535;
    // color: #FFFFFF;
    // background: #D76535;
  }
}
</style>
